export default __webpack_public_path__ + "static/media/032-dressing-table.37eaac0f.svg";